import {EndpointEnum} from "../../constants/EndpointEnum";
import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import IStore from "../../models/IStore";
import EntitlementListModel, { EntitlementModel, UserEntitlementListModel } from "../models/EntitlementModel";
import * as EffectUtility from '../../utilities/EffectUtility';

export default class EntitlementEffect {

    public static async getEntitlementList(state: IStore):Promise<EntitlementListModel | HttpErrorResponseModel> {
        return await EffectUtility.getToModel<EntitlementListModel>(state, EntitlementListModel, EndpointEnum.entitlementList);
    }

    public static async updateEntitlement(state: IStore,entitlementData: EntitlementModel): Promise<EntitlementModel | HttpErrorResponseModel> {
        return EffectUtility.putToModel<EntitlementModel>(state, EntitlementModel, EndpointEnum.entitlementUpdate,entitlementData);
    }

    public static async deleteAllEntitlementsOfUser(state: IStore, userId: string): Promise<EntitlementListModel | HttpErrorResponseModel> {
        return EffectUtility.deleteToModel(state, EntitlementListModel, EndpointEnum.entitlementDeletePerUser.replace(':userId', userId));
    }
    
    public static async deleteEntitlement(state: IStore, userId: string, productId:string): Promise<EntitlementListModel | HttpErrorResponseModel> {
        return EffectUtility.deleteToModel(state, EntitlementListModel, EndpointEnum.entitlementDelete.replace(':userId', userId).replace(':productId', productId));
    }

    public static async createEntitlement(state: IStore, model: EntitlementListModel): Promise<EntitlementListModel | HttpErrorResponseModel> {
        return EffectUtility.postToModel(state, EntitlementListModel, EndpointEnum.entitlementCreate, model);
    }

    public static async createEntitlementList(state: IStore, model: EntitlementListModel[]): Promise<String | HttpErrorResponseModel> {
        return EffectUtility.postToModel(state, String, EndpointEnum.entitlementCreateList, model);
    }

    public static async getEntitlementListLoggedUser(state: IStore):Promise<UserEntitlementListModel[] | HttpErrorResponseModel> {
        return await EffectUtility.getToModel<UserEntitlementListModel[]>(state, UserEntitlementListModel, EndpointEnum.loggedUserEntitlements);
    }
}